import React, { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { SupText } from "../../../../components/UI/Text";

export interface EmptyAvatarProps {
  variant?: "square" | "circular";
  border?: boolean | "solid" | "dashed" | "ring";
  content?: ReactNode;
  className?: string;
  zIndex?: number;
}

const AVATAR_STYLES = {
  square: "",
  circular: "rounded-full",
} as const;

const BORDER_STYLES = {
  solid: "border border-neutral-50",
  dashed: "border border-dashed border-neutral-50",
  ring: "border border-neutral-600 relative before:content-[''] before:absolute before:inset-0 before:border before:border-neutral-50",
} as const;

export const SupEmptyAvatar = ({ className, variant = "circular", border = false, content, zIndex }: EmptyAvatarProps) => {
  const borderStyle = border === true ? "solid" : border;
  return (
    <span
      className={twMerge(
        "sup-avatar-empty inline-flex h-10 w-10 text-neutral-50 bg-neutral-600 justify-center items-center overflow-hidden",
        AVATAR_STYLES[variant],
        borderStyle && BORDER_STYLES[borderStyle],
        variant === "circular" && borderStyle === "ring" && "before:rounded-full",
        className
      )}
      style={{ zIndex }}
    >
      {typeof content === "string" ? (
        <SupText as="span" weight="bold" variant="button">
          {content}
        </SupText>
      ) : (
        content
      )}
    </span>
  );
};
